import { z } from "zod";
import { schemes } from "@zeal/common";
import { createInvoiceResponseSchema } from "../createInvoice/createInvoice.schema";

/**
 * Request schema for GET /api/invoices
 * Response schema for GET /api/invoices
 */

export const getInvoicesRequestSchema = z.object({
  companyID: schemes.companyID(),
  search: z.string().optional().default(""),
  limit: z.number().min(1).max(100).optional(),
  // Cursor can be legacy ObjectId or base64-encoded cursor from cursorPaginate
  start_at: z.string().min(1).optional(),
  sort_by: z.string().optional(),
  sort_direction: z.enum(["asc", "desc"]).optional(),
  status: z.string().optional(),
  payment_status: z.string().optional(),
  invoiceDateFrom: z.string().optional(),
  invoiceDateTo: z.string().optional(),
  dueDateFrom: z.string().optional(),
  dueDateTo: z.string().optional(),
  /** Raw query passed through so filters are applied when top-level params are stripped */
  _query: z.record(z.union([z.string(), z.array(z.string())])).optional(),
});

export type TGetInvoicesRequest = z.infer<typeof getInvoicesRequestSchema>;

export interface IGetInvoicesFilterParams {
  readonly status?: string;
  readonly payment_status?: string;
  readonly invoiceDateFrom?: string;
  readonly invoiceDateTo?: string;
  readonly dueDateFrom?: string;
  readonly dueDateTo?: string;
}

export const getInvoicesResponseSchema = z.object({
  invoices: z.array(
    createInvoiceResponseSchema.extend({
      customer_name: z.string(),
      customer_email: z.string().optional(),
    })
  ),
});

export type TGetInvoicesResponse = z.infer<typeof getInvoicesResponseSchema>;

/** Single invoice from getInvoices response (element of response.invoices array) */
export type TGetInvoicesResponseInvoice =
  TGetInvoicesResponse["invoices"][number];
